import { getCurrentGroupSmtpAddress, getGroupResourceUrl } from 'owa-groups-shared-store';
import { startSharePointResourceTokenFetch } from './startSharePointResourceTokenFetch';
import { ensureGroupSiteCreation } from './ensureGroupSiteCreation';
import commandBarStore from 'owa-group-header-store/lib/store/CommandBarStore';
import NavigationButton from 'owa-group-header-store/lib/store/schema/NavigationButton';
import { isFeatureEnabled } from 'owa-feature-flags';
import { delay } from '../utils/addDelay';

// perform all the actions that we want to do when get group details call is succeeded
// Make sure to have everything in this file as async. We don't want to have any performance impact on loading files view due to any function being called here.
// This method should be used to start any asynchronous calls/processing we want to do when user navigates to files.
export async function onGetGroupDetailsSucceeded(smtpAddress: string) {
    const groupWebAbsoluteUrl = getGroupResourceUrl(smtpAddress, 'Site');

    // Only proceed if the groupWebAbsoluteUrl is not null or undefined or empty string
    if (groupWebAbsoluteUrl) {
        if (commandBarStore.navigationButtonSelected == NavigationButton.Files) {
            // async function to start the prefetch of access Token and update the store with the status
            startSharePointResourceTokenFetch(groupWebAbsoluteUrl)
                .then(() => {
                    ensureGroupSiteCreation(smtpAddress)
                        .then(() => {
                            // When polling is done group site url may change from www.sharepoint.com to www.sharepoint-df.com
                            // We need fetch token for the provisioned url
                            if (
                                getCurrentGroupSmtpAddress().toLowerCase() ==
                                smtpAddress.toLowerCase()
                            ) {
                                startSharePointResourceTokenFetch(
                                    getGroupResourceUrl(smtpAddress, 'Site')
                                ).catch(() => {
                                    // startSharePointResourceTokenFetch will only throw rejection when token fetch is already started by some other process.
                                    // so if it's already started we just catch the rejection and do nothing as we don't want to throw the rejection on window
                                });
                            }
                        })
                        .catch(() => {
                            // do nothing if polling failed
                        });
                })
                .catch(() => {
                    // startSharePointResourceTokenFetch will only throw rejection when token fetch is already started by some other process or there is a permanent exception while trying to get the token.
                    // so if it's already started or the error is permanent we just catch the rejection and do nothing as we don't want to throw the rejection on window
                });
        } else if (commandBarStore.navigationButtonSelected == NavigationButton.Email) {
            if (isFeatureEnabled('grp-prefetchSPTokenFromConversations')) {
                // waiting for 1.5 seconds before starting the prefetchToken call because we want to make sure all the conversation calls are finished. we don't want any prefetch to affect the conversation performance.
                await delay(1500);
                const currentGroupSmtp = getCurrentGroupSmtpAddress().toLowerCase(); // current group might have changed

                if (
                    smtpAddress.toLowerCase() == currentGroupSmtp &&
                    commandBarStore.navigationButtonSelected == NavigationButton.Email
                ) {
                    const groupSiteUrl = getGroupResourceUrl(currentGroupSmtp, 'Site');

                    startSharePointResourceTokenFetch(groupSiteUrl).catch(() => {
                        // startSharePointResourceTokenFetch will only throw rejection when token fetch is already started by some other process or there is a permanent exception while trying to get the token.
                        // so if it's already started or the error is permanent we just catch the rejection and do nothing as we don't want to throw the rejection on window
                    });
                }
            }
        }
    }
}
